import { Link } from 'react-router-dom';
import SectionHeading from '@/components/base/SectionHeading';
import { categories } from '@/mocks/navData';
import { getCountByCategory } from '@/utils/nav';

export default function CategoryShortcuts() {
  return (
    <section className="mt-10">
      <SectionHeading
        eyebrow="快捷入口"
        title="焦点分类"
        description="按领域快速进入对应分类，浏览该领域的优质网站推荐。"
      />
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-6">
        {categories.map((category) => (
          <Link
            key={category.slug}
            to={`/category/${category.slug}`}
            className="group flex cursor-pointer flex-col items-center gap-3 rounded-lg border border-background-200 bg-background-50 p-4 text-center transition-colors hover:border-primary-300 hover:bg-primary-50/60"
          >
            <span className="flex h-12 w-12 items-center justify-center rounded-lg bg-primary-100 text-2xl text-primary-600 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
              <i className={category.icon}></i>
            </span>
            <span className="font-heading text-sm font-semibold text-foreground-950">
              {category.label}
            </span>
            <span className="text-xs text-foreground-500">
              {getCountByCategory(category.slug)} 个站点
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}